import { Routes, Route } from 'react-router-dom';
import Home from './home/home.js';
import Quienes from './components/Quienes_somos/quienes_somos.js';
import Layout from './home/Layout.js';
import NoMatch from './index.css';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/quienes" element={<Layout><Quienes /></Layout>} />
      <Route path="*" element={<Layout><NoMatch /></Layout>} />
    </Routes>
  );
}

export default AppRoutes;